import { readOnly } from '@ember/object/computed';
import ThirdPartyFeeAmountDetail from '@square/dashboard-data/models/squareup/beemo/api/v2/models/third-party-fee-amount-detail';
import { attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import ReportingAmounts, { ProcessingFeeAmounts } from '@square/dashboard-data/models/squareup/bills/reporting-amounts';

/**
 * Note: This file exists because of an unfortunate naming discrepancy between beemo and bill tender ProcessingFeeAmounts.
 *
 * In beemo's model, the Third Party Fee related entries is called third_party_fee_amount_details (with an s)
 * In the bill tender model, it's called third_party_fee_amount_detail (no s).
 *
 * This serves as an adapter that adapts the tender model to beemo's.
 */
const BillTenderProcessingFeeAmounts = ProcessingFeeAmounts.extend({
  thirdPartyFeeAmountDetail: repeated(ThirdPartyFeeAmountDetail),
  thirdPartyFeeAmountDetails: readOnly('thirdPartyFeeAmountDetail')
});
export default ReportingAmounts.extend({
  processingFeeAmounts: attr(BillTenderProcessingFeeAmounts)
});